import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowUpRight, Quote } from 'lucide-react';
const reviews = [{
  name: 'Sarah M.',
  suburb: 'Karrinyup',
  date: 'October 2025',
  quote: 'Mike came out, measured up, and gave us a fixed quote on the spot. No upsell, no hidden costs. The ducted system has been faultless through summer. They left the place spotless.',
  system: 'Ducted reverse cycle'
}, {
  name: 'David T.',
  suburb: 'Balcatta',
  date: 'September 2025',
  quote: "We had three quotes. Langler weren't the cheapest, but Mike was the only one who actually did load calculations for our house. Six months in, the system runs less than the others quoted.",
  system: 'Mitsubishi split'
}, {
  name: 'Emma L.',
  suburb: 'Duncraig',
  date: 'August 2025',
  quote: 'Honest from the first phone call. They talked us out of a bigger system than we needed. Install was clean, the team explained the controls properly, and they followed up a week later.',
  system: '5-zone ducted'
}, {
  name: 'James W.',
  suburb: 'Hillarys',
  date: 'August 2025',
  quote: 'Replaced a 15-year-old unit. Mike was the only installer who actually came out before quoting. Job done in a day, place was cleaner when they left than when they arrived.',
  system: 'Daikin split'
}, {
  name: 'Priya K.',
  suburb: 'Subiaco',
  date: 'July 2025',
  quote: "Got finance through Brighte, paid less than my old place's bill. Mike walked through everything in plain English. Genuinely felt like dealing with a mate not a tradie.",
  system: 'Multi-head split'
}, {
  name: 'Tom B.',
  suburb: 'Joondalup',
  date: 'June 2025',
  quote: "Three weeks after install I noticed a small drainage issue. Called Mike, he was there next morning, fixed it, no invoice. That's the difference.",
  system: 'Ducted with iZone'
}];
export function Reviews() {
  return <section id="reviews" className="bg-paper py-20 md:py-28" data-id="element-630">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-631">
        <div className="grid lg:grid-cols-12 gap-10 mb-12" data-id="element-632">
          <div className="lg:col-span-7" data-id="element-633">
            <div className="kicker mb-3" data-id="element-634">Real reviews, real names</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-635">
              75 five-star reviews. Zero one-stars. Ever.
            </h2>
          </div>

          <div className="lg:col-span-5 lg:pl-8 lg:border-l border-stone-300 flex flex-col justify-end" data-id="element-636">
            <a href="https://www.google.com/search?q=langler+air+perth+reviews" target="_blank" rel="noopener noreferrer" className="group inline-flex flex-col items-start" data-id="element-637">
              <div className="flex items-center gap-3 mb-3" data-id="element-638">
                <div className="flex" data-id="element-639">
                  {[0, 1, 2, 3, 4].map(i => <Star key={i} size={22} className="fill-amber-400 text-amber-400" data-id="element-640" />)}
                </div>
                <span className="font-display text-3xl font-extrabold tabular-nums" data-id="element-641">
                  5.0
                </span>
              </div>
              <p className="text-base text-stone-700 mb-3 max-w-sm" data-id="element-642">
                Across 75 verified Google reviews. Every one of them has a name
                and a suburb.
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-bold text-brand group-hover:gap-2.5 transition-all" data-id="element-643">
                See all 75 on Google
                <ArrowUpRight size={15} data-id="element-644" />
              </span>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-645">
          {reviews.map((review, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-white rounded-2xl p-7 border border-stone-200 shadow-sm flex flex-col" data-id="element-646">
              <Quote size={24} className="text-brand mb-4" strokeWidth={1.5} data-id="element-647" />
              <blockquote className="text-base leading-relaxed text-ink-900 flex-grow mb-6" data-id="element-648">
                {review.quote}
              </blockquote>
              <div className="pt-5 border-t border-stone-200 flex items-center justify-between" data-id="element-649">
                <div data-id="element-650">
                  <div className="font-bold text-ink-900 text-sm" data-id="element-651">
                    {review.name}
                  </div>
                  <div className="text-xs text-stone-500 mt-0.5" data-id="element-652">
                    {review.suburb} · {review.date}
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1" data-id="element-653">
                  <div className="flex" data-id="element-654">
                    {[0, 1, 2, 3, 4].map(s => <Star key={s} size={11} className="fill-amber-400 text-amber-400" data-id="element-655" />)}
                  </div>
                  <span className="text-[10px] font-semibold text-stone-500 uppercase tracking-wider" data-id="element-656">
                    Google
                  </span>
                </div>
              </div>
              <div className="mt-3 inline-flex items-center px-2 h-5 rounded-full bg-stone-100 text-[11px] font-medium text-stone-700 w-fit" data-id="element-657">
                {review.system}
              </div>
            </motion.div>)}
        </div>

        <p className="mt-10 text-center text-xs text-stone-500" data-id="element-658">
          Reviews shown above are verbatim from our Google Business Profile. We
          do not edit, filter or curate.
        </p>
      </div>
    </section>;
}